import ServerDirections from '@/config/server-directions'
import { ProfileType } from '@/entities/ProfileType'

import { RequestService } from '@/services/request.service'
const requestService = new RequestService()

export class ProfileTypeRequests {
  list () {
    const route = ServerDirections.PROFILE_TYPES
    const method = 'get'
    function map (data) {
      return data.map(item => new ProfileType(item))
    }
    return requestService.makePromise(route, method, {}, map)
  }
}
